/** Couleurs de marque JCONSULT (primaire #872320). */
export const palette = {
  primary: '#872320',
  primaryDark: '#6b1b18',
  primaryLight: '#ede4e4',
  /** Texte secondaire / pictogrammes discrets sur fond clair. */
  textMuted: '#5c6368',
} as const;
